<div class="row bg-white p-3 mt-2">
  <div class="col-md-12 text-center">
    <h5 class="text-primary pb-2">
      {{ headingText }}
      <p class="text-danger" *ngIf="required">*</p>
    </h5>
  </div>
  <div _ngcontent-owi-c328="" class="text-danger fw-bold heading mb-2" *ngIf="getAssignedToBeCount() > 0"> Videos to be assigned <span _ngcontent-owi-c328="" class="badge bg-danger">{{getAssignedToBeCount()}}</span></div>
  <div class="data-grid bg-gray table-responsive pb-0">
    <table mat-table [dataSource]="dataSource" class="table">
      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef class="col-2">File Name</th>
        <td mat-cell *matCellDef="let element">
          <div class="file-name-wrapper">
            <div class="file-name">{{ element.originalFileName }}</div>
            <div *ngIf="getConversionError(element.studyFileId)" class="conversion-failed-badge">
              <i class="fa fa-times-circle"></i> Conversion Failed
            </div>
          </div>
        </td>
      </ng-container>
      <!--<ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef class="w-4-rem">Date</th>
    <td mat-cell *matCellDef="let element">
      {{ element.studyStatusDate | date : "medium" }}
    </td>
  </ng-container>-->
      <ng-container matColumnDef="videoType">
        <th mat-header-cell *matHeaderCellDef class="col-2">Video Type</th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.documentTypeName">{{ element.documentTypeName }}</span>
          <span *ngIf="element.documentTypeName" class="float-end"><button class="btn btn-outline-warning btn-sm me-2" (click)="openDocTypePopup(element,false)"><i class="fa fa-edit"></i></button></span>
          <button *ngIf="!element.documentTypeName" type="button" class="btn btn-warning btn-sm" (click)="openDocTypePopup(element,false)">Assign</button>
        </td>
      </ng-container>
      <ng-container matColumnDef="details">
        <th mat-header-cell *matHeaderCellDef class="col-1">Format</th>
        <td mat-cell *matCellDef="let element">{{ element.mimeType }}</td>
      </ng-container>
      <ng-container matColumnDef="uploadedby">
        <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded By</th>
        <td mat-cell *matCellDef="let element">{{ element.createdByUser?.name }}</td>
      </ng-container>
      <ng-container matColumnDef="uploadeddate">
        <th mat-header-cell *matHeaderCellDef class="col-2">Uploaded Date/Time</th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdDate | date }}
          {{ element.createdDate | date : "hh:mm:ss a" }}
        </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="col-1">Status</th>
        <td mat-cell *matCellDef="let element">
          <span class="form-control study-status-box study-status-box-{{
                element.studyStatusId
              }}">
            {{ element.studyStatus }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="col"></th>
        <td mat-cell *matCellDef="let element">
          <button class="btn btn-outline-info btn-sm me-2"
                  (click)="emitOpenButtonClicked(element.studyFileId)">
            <i class="fa fa-eye"></i> PREVIEW
          </button>
          <button class="btn btn-outline-danger btn-sm"
                  (click)="emitDeleteButtonClicked(element.studyFileId)">
            <i class="fa fa-trash"></i> REMOVE
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row
          *matRowDef="let row; columns: displayedColumns"
          class="border-start-0 border-end-0 pt-2"></tr>
    </table>
  </div>
</div>
